import React, { useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
	dateFormatter,
	buttonsStyle,
	imageFormatter,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getBoats, deleteBoat } from "../../../../api/boat";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getSailors } from "../../../../api/sailor";
import { getBoatTypes } from "../../../../api/boattype";

function getData(boats, sailors, boatTypes) {
	let data = [];
	for (let i = 0; i < boats.length; ++i) {
		const elem = {};
		elem.name = boats[i].fullName;
		elem.image = boats[i].image;
		elem.boatType = boats[i].boatType
			? boatTypes.find((cat) => cat._id === boats[i].boatType)?.fullName
			: "---";
		elem.sailor = boats[i].sailor
			? sailors.find((cat) => cat._id === boats[i].sailor)?.fullName
			: "---";
		elem.createdAt = boats[i].createdAt;
		elem.id = boats[i]._id;
		data = data.concat(elem);
	}
	return data;
}

export default function BoatsPage() {
	const [data, setData] = useState([]);
	const [boatId, setBoatId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();

	function buttonFormatter(cell) {
		return (
			<>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-boat/" + cell)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Delete">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setBoatId(cell);
							setOpenConfirmDialog(true);
						}}
					>
						<DeleteIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "image",
			text: "",
			formatter: imageFormatter,
			headerStyle: () => ({ width: "50px" }), },
		{ dataField: "name", text: "Full name", sort: true },
		{ dataField: "boatType", text: "Boat type", sort: true },
		{ dataField: "sailor", text: "Sailor", sort: true },
		{
			dataField: "createdAt",
			text: "Created at",
			formatter: dateFormatter,
			sort: true,
			headerStyle: () => ({ width: "150px" }),
		},
		{ dataField: "id",
			text: "",
			formatter: buttonFormatter,
			headerStyle: () => ({ width: "150px" }), },
	];

	useEffect(() => {
		getBoats()
			.then((res) => {
				if (res.status === 200) {
					getSailors()
						.then((respSailors) => {
							if (respSailors.status === 200) {
								getBoatTypes()
									.then((respBoatTypes) => {
										if (respBoatTypes.status === 200) {
											setData(getData(res.data, respSailors.data, respBoatTypes.data));
											setRefresh(false);
										}
									})
									.catch((error) => {
										alertError({
											error: error,
											customMessage: "Could not get boat types.",
										});
									});
							}
						})
						.catch((error) => {
							alertError({
								error: error,
								customMessage: "Could not get sailors.",
							});
						});
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get boats.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Boats list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-boat")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={"Are you sure you want to remove this boat?"}
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteBoat(boatId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Boat removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not remove boat.",
									});
								});
						}}
					>
						{"This will erase all their members and their answers"}
					</ConfirmDialog>
				</CardBody>
			</Card>
		</>
	);
}
